"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// shout out to stack overflow, making our lives easier since 2008: https://stackoverflow.com/a/21125098
function getCookieValue(cookie, cookieName) {
    var match = cookie.match(new RegExp('(^| )' + cookieName + '=([^;]+)'));
    return match ? match[2] : null;
}
exports.getCookieValue = getCookieValue;
//# sourceMappingURL=CookieHelpers.js.map